var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',[_c('Loader')],1):_c('div',[(_vm.iSKolahduzan)?_c('KolahduzanPrint'):_c('Print')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }